<template>
  <vue-guided-tour :steps="homeStep" :pagination="false">
      <template #content="{ stepIndex }">
          <div class="vgt__body">{{ homeStep[stepIndex].content }}</div>
      </template>
      <template #close>
          <button class="vgt__close-btn" aria-label="close Tour" @click="$vgt.end"> × </button>
      </template>
      <template #nav="{ stepIndex, isFirstStep, isLastStep }">
          <div class="vgt__nav">
              <button v-if="!isFirstStep" class="vgt__btn vgt__btn--secondary vgt__prev-btn" @click="$vgt.prev">이전</button>
              <button v-if="isLastStep" class="vgt__btn vgt__btn--primary vgt__end-btn" @click="$vgt.end">닫기</button>
              <button v-else class="vgt__btn vgt__btn--primary vgt__next-btn" @click="$vgt.next">다음{{ stepIndex }}</button>
          </div>
      </template>
  </vue-guided-tour>
  <div class="container">
    <div class="row" style="margin-top: 1.8rem;">
      <h4 class="orange_bar"></h4>
      <h4 class="fs-23 text-left mt-2" style="font-weight:700">{{shelter.city}} {{shelter.country}}</h4>
    </div>

    <div class="hstack w-100 home-admin-bar" v-if="$root.isAdmin">

        <router-link class="ms-auto navbar-brand me-3" to='/statistics'>
            <button type="button" class="btn btn-outline-orange fr" style="height : 30px; line-height: 1; min-width: 80px;">관리자 통계</button>
        </router-link>
        <select class="form-select form-select-sm fr w-auto" style="max-width:180px" @change="shelterSelected($event);" v-model="admin_shelter">
            <option selected>보호소</option>
            <option v-for="shelter, index in $root.admin.shelterList" :value="shelter.shelter_name">{{ shelter.shelter_name }}</option>
        </select>
    </div>

    <!-- 확인 필요: 처리하면 사라지는 알림 (utils/todoStore, 헤더 ⚠ 와 같은 데이터). 카드를 누르면 목록 창 -->
    <!-- 보류 (2026-10-28): 홈 확인 필요 섹션 숨김 — 다시 쓰려면 SHOW_HOME_TODO = true -->
    <div class="home-todo" v-if="SHOW_HOME_TODO && shelter && shelter.shelter_device_number && shelter.shelter_device_number != 'admin@pasm.kr'">
      <div class="hstack gap-2 home-todo-head">
        <h4 class="fs-20 mb-0">확인 필요</h4>
      </div>
      <div class="home-todo-cards">
        <button v-for="t in TODO_TYPES" :key="t.key" type="button" class="home-todo-card" :class="todo.counts[t.key] ? 'has' : ''" @click="emitter.emit('openTodoModal', { type: t.key })">
          <span class="home-todo-label"><i class="bi" :class="t.icon"></i> {{ t.label }}</span>
          <span class="home-todo-count">{{ todo.counts[t.key] || 0 }}<small>건</small></span>
          <span v-if="t.key == 'vaccine' && vaccineOverdue > 0" class="home-todo-extra">지남 {{ vaccineOverdue }}</span>
        </button>
      </div>
    </div>

    <!-- 홈 요약 4칸: 오늘 일정 · 상담중인 동물 · 오늘 접수된 입양신청서 · 추천동물 현황 -->
    <HomeSummary v-if="shelter && shelter.shelter_device_number && shelter.shelter_device_number != 'admin@pasm.kr'" :shelter="shelter"/>

    <!-- 일정 캘린더: 보호소 공유 일정 + 입양신청·접종 예정·키트 재검사·공고 종료 (관리자 계정은 제외) -->
    <HomeCalendar v-if="shelter && shelter.shelter_device_number && shelter.shelter_device_number != 'admin@pasm.kr'" :shelter="shelter"/>

    <div class="step-1">
      <!-- 추천동물 · 입양신청 (기간: 올해 / 연도별 / 직접설정(월)) -->
      <div class="home-stat-head">
        <div>
          <h4 class="fs-20 mb-0">추천동물 입양 현황</h4>
          <p class="home-period">{{ periodText(start_date2, end_date2) }}</p>
        </div>
        <HomePeriodFilter class="step-2" @change="onRecommendedPeriod"/>
      </div>
      <div class="home-bars-grid">
        <HomeBars title="추천동물 현황" total-label="추천동물" :total="recommended_all_cnt" :items="barItems(recommendedData, STATE_COLORS)"/>
        <HomeBars title="입양신청 현황" total-label="신청서" unit="건" :total="request_all_cnt" :items="barItems(adoptRequestData, REQUEST_COLORS)"/>
      </div>

      <!-- 보호 현황 -->
      <div class="home-stat-head">
        <div>
          <h4 class="fs-20 mb-0">보호 현황</h4>
          <p class="home-period">{{ periodText(start_date, end_date) }}</p>
        </div>
        <HomePeriodFilter @change="onProtectPeriod"/>
      </div>
      <div class="home-bars-grid">
        <HomeBars title="상태별" total-label="전체 두수" :total="animal_all_cnt" :items="barItems(stateData, STATE_COLORS)"/>
        <HomeBars title="축종별" total-label="전체 두수" :items="barItems(speciesData, SPECIES_COLORS)"/>
      </div>

      <div class="home-rank">
          <p class="mb-0"><span class="fw-600">입양률</span> {{shelter.city}} 내 <b>{{adopt_rank}}</b>위 <span class="home-rank-sep">·</span> <span class="fw-600">안락사율</span> {{shelter.city}} 내 <b>{{euth_rank}}</b>위</p>
          <button type="button" class="btn btn-orange" @click="redirectStatisticsPage()">지역별 통계보기</button>
      </div>


    </div>
    <div class="step-first floating-button-layer">
      <button class="floating-button" @click="$vgt.start(1)">
        <img src="@/assets/img/question_icon.png" class="rounded-image" />
      </button>
    </div>
  </div>
</template>

<script>

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables, ChartDataLabels);

const moment = require('moment');
import { ref } from 'vue';
import { todoState, TODO_MODAL_TYPES as TODO_TYPES, loadTodo } from '@/utils/todoStore';
import HomeCalendar from '@/components/home/HomeCalendar.vue';
import HomeSummary from '@/components/home/HomeSummary.vue';
import HomeBars from '@/components/home/HomeBars.vue';
import HomePeriodFilter from '@/components/home/HomePeriodFilter.vue';

//홈 통계 막대 색 (라벨 순서와 같음)
const STATE_COLORS = ['#527cf1', '#F6951C', '#1FA971', '#8E8E93', '#E5484D', '#8063a2', '#4aacc6'];   //보호중·입양·반환·자연사·안락사·기증·방사
const REQUEST_COLORS = ['#F6951C', '#0d6efd', '#F5B700', '#A9A9A9', '#CFCFCF'];   //입양·상담중·대기중·반려·취소
const SPECIES_COLORS = ['#F6951C', '#527cf1', '#9bbb59'];   //개·고양이·기타

export default {
  name: 'HomeView',
  components: {
    HomeCalendar,
    HomeSummary,
    HomeBars,
    HomePeriodFilter,
  },
  data(){
    return {
      todo: todoState,
      SHOW_HOME_TODO: false,   //홈 '확인 필요' 카드 (헤더 ⚠·목록 표시는 그대로)
      TODO_TYPES,
      STATE_COLORS, REQUEST_COLORS, SPECIES_COLORS,

      //가이드 투어
      homeStep: [
        {
          target: '.step-first',
          content: '이 곳을 누르면 해당 화면의 설명을 볼 수 있습니다.',
        },
        {
          target: '.step-1',
          content: '보호소의 통계자료를 확인할 수 있습니다.',
        },
        {
          target: '.step-2',
          content: '통계자료의 조건을 설정할 수 있습니다.',
        },
      ],

      shelter : {},

      search :{
        start_date: moment().subtract(3,'months'),
          end_date: moment(),
      },
      search2 : {
        start_date: moment('2022-01-01').toISOString(),
        end_date: moment(),
      },

      //기간 기본 = 올해 (HomePeriodFilter 에서 바꿈)
      start_date: moment().startOf('year').toDate(),
      end_date: moment().toDate(),

      start_date2: moment().startOf('year').toDate(),
      end_date2: moment().toDate(),

      recommended_all_cnt : 0,
      request_all_cnt : 0,
      animal_all_cnt : 0,
      // report_all_cnt : 0,

      adopt_rank : 0,
      euth_rank : 0,

      // all_treatment_expenses: 0,

      // treatmentCheckBox : false,

      backgroundColor: ['#436d9f', '#c0504d', '#9bbb59', '#8063a2', '#4aacc6', '#2d4d75', '#c0504d'],
      
      recommendedData : {
        labels: ['보호중','입양','반환','자연사','안락사','기증','방사'],
        datasets: [
          {
            data: [],
            backgroundColor: ['#436d9f', '#c0504d', '#9bbb59', '#8063a2', '#4aacc6', '#2d4d75', '#c0504d'],
          },
        ],
        options :{
          cutout: 150,
          tooltip: { enabled: false },
          hover: { mode: null },
          events: [],
          plugins: {

            legend: {
              display: false,
              // position: "bottom",
              // labels: {

              //   boxWidth: 15,
              //   boxHeight: 15,

              //   padding: 20,

              //   afterFit : function() {
              //     this.height = this.height + 500;
              //   }
                

              // },


            },
            title: {
              display: false,
              text: "상태별",
            },

            datalabels: {
              color: "#000",
              backgroundColor : '#fff',
              borderRadius : 5,
              offset : -50,
              align : 'end',

              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            },
          },

          
        },

        
      }, 
      adoptRequestData : {
        labels: ['입양','상담중','대기중','반려','취소'],
        
        datasets: [
          {
            data: [],
            backgroundColor: ['#f6951c', '#0d6efd', '#ffc107', '#a9a9a9', '#ededed'],
          },
        ],
        options :{
          cutout: 150,
          tooltip: { enabled: false },
          hover: { mode: null },
          events: [],
          plugins: {

            legend: {
              display: false,
              // position: "bottom",
              // labels: {

              //   boxWidth: 15,
              //   boxHeight: 15,

              //   padding: 20,

              //   afterFit : function() {
              //     this.height = this.height + 500;
              //   }
                

              // },


            },
            title: {
              display: false,
              text: "상태별",
            },

            datalabels: {
              color: "#000",
              backgroundColor : '#fff',
              borderRadius : 5,
              offset : -50,
              align : 'end',

              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            },
          },

          
        },
        
      },

      stateData : {
        labels: ['보호중','입양','반환','자연사','안락사','기증','방사'],
        datasets: [
          {
            data: [],
            backgroundColor: ['#436d9f', '#c0504d', '#9bbb59', '#8063a2', '#4aacc6', '#2d4d75', '#c0504d'],
          },
        ],
        options :{
          cutout: 150,
          tooltip: { enabled: false },
          hover: { mode: null },
          events: [],
          plugins: {

            legend: {
              display: false,
              // position: "bottom",
              // labels: {

              //   boxWidth: 15,
              //   boxHeight: 15,

              //   padding: 20,

              //   afterFit : function() {
              //     this.height = this.height + 500;
              //   }
                

              // },


            },
            title: {
              display: false,
              text: "상태별",
            },

            datalabels: {
              color: "#000",
              backgroundColor : '#fff',
              borderRadius : 5,
              offset : -50,
              align : 'end',

              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            },
          },

          
        },

        
      }, 
      speciesData : {
        labels: ['개','고양이','기타'],
        
        datasets: [
          {
            data: [],
            backgroundColor: ['#436d9f', '#c0504d', '#9bbb59'],
          },
        ],
        options :{
          events: [],
          cutout: 0,
          plugins: {
            legend: {
              display: false,
              position: "bottom",
            },
            title: {
              display: false,
              text: "축종별",
            },
            datalabels: {
              color: "white",
              textAlign: "center",
              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            }
          },
        }
        
      },
      /*
      reportData : {
        labels: ['접수','구조','미구조','보호자 인계'],
        
        datasets: [
          {
            data: [],
            backgroundColor: ['#436d9f', '#c0504d', '#9bbb59', '#8063a2'],
          },
        ],
        options :{
          events: [],
          cutout: 150,
          tooltip: { enabled: false },
          hover: { mode: null },
          events: [],
          plugins: {

            legend: {
              display: false,

            },
            title: {
              display: false,
              text: "상태별",
            },

            datalabels: {
              color: "#000",
              backgroundColor : '#fff',
              borderRadius : 5,
              offset : -50,
              align : 'end',
              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            }
          },
        }
        
      },
      treatmentData : {
        labels: [],
        
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        options :{
          events: [],
          cutout: 150,
          tooltip: { enabled: false },
          hover: { mode: null },
          events: [],
          plugins: {

            legend: {
              display: false,

            },
            title: {
              display: false,
              text: "진료현황",
            },

            datalabels: {
              color: "#000",
              backgroundColor : '#fff',
              borderRadius : 5,
              offset : -50,
              align : 'end',
              formatter: function(value, context) {

                let all_cnt = 0;
                for(let i = 0 ; i < context.dataset.data.length ; i++){
                  all_cnt += context.dataset.data[i];
                }

                if(context.dataset.data[context.dataIndex] != 0){
                  return context.chart.legend.legendItems[context.dataIndex].text + ' ' +((context.dataset.data[context.dataIndex]/all_cnt) * 100).toFixed(0) + '%';
                }else{
                  return '';
                }
              }
            }
          },
        }
        
      },
      */
    }

  },
  setup() {
    const date = ref();
    
    const handleDate = (modelData) => {
      alert(modelData);
      // do something else with the data
    }

    // In case of a range picker, you'll receive [Date, Date]
    const format = (date) => {

        let MyDateString = date.getFullYear() + '-' 
          + ('0' + (date.getMonth()+1)).slice(-2) + '-'
          +('0' + date.getDate()).slice(-2) + '' ;

        return `${MyDateString}`;
    }

    // const testData = {
    //   labels: ['Paris', 'Nîmes', 'Toulon', 'Perpignan', 'Autre'],
    //   datasets: [
    //     {
    //       data: [30, 40, 60, 70, 5],
    //       backgroundColor: ['#77CEFF', '#0079AF', '#123E6B', '#97B0C4', '#A5C8ED'],
    //     },
    //   ],
    // };

    return { date, format };
  },
  computed: {
    //접종 예정 중 이미 지난 건수 (홈 카드 빨간 보조 문구)
    vaccineOverdue() {
      return ((this.todo.items && this.todo.items.vaccine) || []).filter(i => i.days < 0).length;
    },
  },
  methods :{

// ************************************************************** api method ************************************************************************* //

    getRecommendedStatistics(){
      let me = this;

      me.$root.loadingStart();
      this.search2.start_date = moment(this.start_date2).format('YYYY-MM-DD');
      this.search2.end_date = moment(this.end_date2).format('YYYY-MM-DD');

      let u = new URLSearchParams(this.search2).toString();

      this.axios.get(`/shelter/statistics/recommended?shelter_device_number=${this.shelter.shelter_device_number}&${u}`)
      .then(function (res) {
          // 실제 API를 요청한다/
          
          me.$root.loadingStop();

          if(res.status === 200){
            let result = res.data[0];

            if(result){
              me.recommended_all_cnt = result.all_cnt;

              me.recommendedData.datasets[0].data = [];

              me.recommendedData.datasets[0].data.push(result.protect_cnt); //보호중
              me.recommendedData.datasets[0].data.push(result.adopt_cnt); //입양
              me.recommendedData.datasets[0].data.push(result.return_cnt); //반환
              me.recommendedData.datasets[0].data.push(result.natural_cnt); //자연사
              me.recommendedData.datasets[0].data.push(result.euthanasia_cnt); //안락사
              me.recommendedData.datasets[0].data.push(result.contribute_cnt); //기증
              me.recommendedData.datasets[0].data.push(result.radiate_cnt); //방사

            }
          }else{
            alert("통계를 불러오지 못했습니다.");
          }
          
      }).catch(function (error) {
          console.log(error);
          // alert('호출 에러');
          me.$root.loadingStop();
      });
    },  

    getAdoptRequestStatistics(){
      let me = this;

      me.$root.loadingStart();
      this.search2.start_date = moment(this.start_date2).format('YYYY-MM-DD');
      this.search2.end_date = moment(this.end_date2).format('YYYY-MM-DD');

      let u = new URLSearchParams(this.search2).toString();

      this.axios.get(`/shelter/statistics/adoptrequest?shelter_device_number=${this.shelter.shelter_device_number}&${u}`)
      .then(function (res) {
          // 실제 API를 요청한다/
          
          me.$root.loadingStop();

          if(res.status === 200){
            let result = res.data[0];

            if(result){

              me.adoptRequestData.datasets[0].data = [];

              me.request_all_cnt = result.all_cnt;

              me.adoptRequestData.datasets[0].data.push(result.adopt_cnt); //
              me.adoptRequestData.datasets[0].data.push(result.connect_cnt); //
              me.adoptRequestData.datasets[0].data.push(result.wait_cnt); //
              me.adoptRequestData.datasets[0].data.push(result.reject_cnt); //
              me.adoptRequestData.datasets[0].data.push(result.cancel_cnt); //

            }
          }else{
            alert("통계를 불러오지 못했습니다.");
          }
          
      }).catch(function (error) {
          console.log(error);
          // alert('호출 에러');
          me.$root.loadingStop();
      });
    },  

    getAnimalStatistics(){
        let me = this;

        me.$root.loadingStart();
        this.search.start_date = moment(this.start_date).format('YYYYMMDD');
        this.search.end_date = moment(this.end_date).format('YYYYMMDD');

        let u = new URLSearchParams(this.search).toString();

        this.axios.get(`/shelter/statistics/animal?shelter_name=${this.shelter.shelter_name}&${u}`)
        .then(function (res) {
            // 실제 API를 요청한다/
            
            me.$root.loadingStop();

            if(res.status === 200){
              let result = res.data;

              if(result){
                me.animal_all_cnt = result.all_cnt;

                // me.stateData.labels = [];
                me.stateData.datasets[0].data = [];

                // me.speciesData.labels = [];
                me.speciesData.datasets[0].data = [];

                // me.stateData.labels.push('보호중 ' + result.protect_cnt);
                // me.stateData.labels.push('입양 ' + result.adopt_cnt);
                // me.stateData.labels.push('반환 ' + result.return_cnt);
                // me.stateData.labels.push('자연사 ' + result.natural_cnt);
                // me.stateData.labels.push('안락사 ' + result.euthanasia_cnt);
                // me.stateData.labels.push('반환 ' + result.contribute_cnt);
                // me.stateData.labels.push('방사 ' + result.radiate_cnt);

                me.stateData.datasets[0].data.push(result.protect_cnt); //보호중
                me.stateData.datasets[0].data.push(result.adopt_cnt); //입양
                me.stateData.datasets[0].data.push(result.return_cnt); //반환
                me.stateData.datasets[0].data.push(result.natural_cnt); //자연사
                me.stateData.datasets[0].data.push(result.euthanasia_cnt); //안락사
                me.stateData.datasets[0].data.push(result.contribute_cnt); //기증
                me.stateData.datasets[0].data.push(result.radiate_cnt); //방사

                // me.speciesData.labels.push('개 ' + result.dog_cnt);
                // me.speciesData.labels.push('고양이 ' + result.cat_cnt);
                // me.speciesData.labels.push('기타 ' + result.other_cnt);

                me.speciesData.datasets[0].data.push(result.dog_cnt); //보호중
                me.speciesData.datasets[0].data.push(result.cat_cnt); //보호중
                me.speciesData.datasets[0].data.push(result.other_cnt); //보호중
              }
            }else{
              alert("통계를 불러오지 못했습니다.");
            }
            
        }).catch(function (error) {
            console.log(error);
            // alert('호출 에러');
            me.$root.loadingStop();
        });
    },
    getAdoptRankByCity(){
        let me = this;

        this.search.start_date = moment(this.start_date).format('YYYYMMDD');
        this.search.end_date = moment(this.end_date).format('YYYYMMDD');

        let u = new URLSearchParams(this.search).toString();

        this.adopt_rank = 0

        // this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + `/shelter/report?offset=${this.page.pageNum}&limit=${this.page.pageSize}`)
        this.axios.get(`/shelter/statistics/rank?city=${this.shelter.city}&type=종료(입양)&${u}`)
        .then(function (res) {
            // 실제 API를 요청한다/
            
            // me.reportList = res.data;

            if(res.status === 200){ 

              let result = res.data;
              // console.log(result)

              // console.log(result);

              if(result.length > 0){
                for(let i = 0 ; i < result.length ; i ++){
                  if(me.shelter.country == result[i].country){
                    me.adopt_rank = i+1;
                  }
                }
              }

            }else{
              alert("통계를 불러오지 못했습니다.");
            }
        }).catch(function (error) {
            console.log(error);
            // alert('호출 에러');
        });
    },
    getEuthRankByCity(){
        let me = this;

        this.search.start_date = moment(this.start_date).format('YYYYMMDD');
        this.search.end_date = moment(this.end_date).format('YYYYMMDD');

        let u = new URLSearchParams(this.search).toString();

        this.euth_rank=0;

        // this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + `/shelter/report?offset=${this.page.pageNum}&limit=${this.page.pageSize}`)
        this.axios.get(`/shelter/statistics/rank?city=${this.shelter.city}&type=종료(안락사)&${u}`)
        .then(function (res) {
            // 실제 API를 요청한다/
            
            // me.reportList = res.data; 

            let result = res.data;

            // console.log(result)

            if(result.length > 0){
              for(let i = 0 ; i < result.length ; i ++){
                if(me.shelter.country == result[i].country){
                  me.euth_rank = i+1;
                }
              }
            }

        }).catch(function (error) {
            console.log(error);
            // alert('호출 에러');
        });
    },
    /*
    getReportStatistics(){
      let me = this;

      this.search2.start_date = moment(this.start_date2).format('YYYY-MM-DD');
      this.search2.end_date = moment(this.end_date2).format('YYYY-MM-DD');

      let u = new URLSearchParams(this.search2).toString();

      this.axios.get(`/shelter/statistics/report?shelter_device_number=${this.shelter.shelter_device_number}&${u}`)
      .then(function (res) {
          // 실제 API를 요청한다/
          
          let result = res.data;

          if(result){
            me.report_all_cnt = result.all_cnt;

            me.reportData.datasets[0].data = [];

            me.reportData.datasets[0].data = [];

            me.reportData.datasets[0].data.push(result.reception_cnt); //접수
            me.reportData.datasets[0].data.push(result.rescue_cnt); //구조
            me.reportData.datasets[0].data.push(result.nonerescue_cnt); //미구조
            me.reportData.datasets[0].data.push(result.return_cnt); //인계
          }

      }).catch(function (error) {
          console.log(error);
          // alert('호출 에러');
      });
    },
    */
    /*
    getTreatmentStatistics(){
      let me = this;

      this.search2.start_date = moment(this.start_date2).format('YYYY-MM-DD');
      this.search2.end_date = moment(this.end_date2).format('YYYY-MM-DD');

      let u = new URLSearchParams(this.search2).toString();

      this.axios.get(`/shelter/treatment/statistics/?shelter_device_number=${this.shelter.shelter_device_number}&${u}`)
      .then(function (res) {
          // 실제 API를 요청한다/
          
          let result = res.data;

          if(result){

            //진료 타입의 종류를 넣어줄 배열
            let result_name_arr = [];

            //해당 타입의 카운트를 계산할 배열
            let result_cnt_arr = [];

            //총 진료비 초기화
            me.all_treatment_expenses = 0;

            let color = 0
            for(let i = 0; i < result.length; i++){
              

              // console.log(result_name_arr.includes(result[i].treatment_type_name));
              //이름이 포함되어있으면 해당 인덱스를 가져와 카운트 ++
              if(result_name_arr.includes(result[i].treatment_type_name)){
                let index = result_name_arr.indexOf(result[i].treatment_type_name);

                result_cnt_arr[index] += 1;
              }else{
                // console.log('color : ', color)
                //포함되어있지 않을 경우 이름 추가
                result_name_arr.push(result[i].treatment_type_name);
                me.treatmentData.labels.push(result[i].treatment_type_name);
                me.treatmentData.datasets[0].backgroundColor.push(me.backgroundColor[color]);
                result_cnt_arr.push(1);
                color += 1;
                
              }

              // console.log(result[i].treatment_expenses)
              me.all_treatment_expenses += parseInt(result[i].treatment_item_expenses);
            }

            me.treatmentData.datasets[0].data = result_cnt_arr;
            me.treatmentData.labels = result_name_arr;
            // me.treatmentData.datasets[0].backgroundColor =


          }


      }).catch(function (error) {
          console.log(error);
          // alert('호출 에러');
      });
    },
*/
    testDate(){

      let me = this;

      // let u = new URLSearchParams(this.search).toString();
      this.search.start_date = moment(this.start_date).format('YYYYMMDD');
      this.search.end_date = moment(this.end_date).format('YYYYMMDD');

      let city = '전 국'
      let country = '전 체'
      
      // this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + `/shelter/report?offset=${this.page.pageNum}&limit=${this.page.pageSize}`)
      this.axios.get(`/statistics/ratebyregion?city=${city}&country=${country}&startdate=${this.search.start_date}&enddate=${this.search.end_date}`)
      .then(function (res) {
          // 실제 API를 요청한다/
          
          // me.reportList = res.data;

          if(res.status === 200){ 

            let result = res.data;

          }else{
            alert("통계를 불러오지 못했습니다.");
          }
      }).catch(function (error) {
          console.log(error);
          // alert('호출 에러');
      });

    },
// ************************************************************** api end ************************************************************************* //

    updateProtectData(){
      this.getAnimalStatistics();
      this.getAdoptRankByCity();
      this.getEuthRankByCity();
    },

    updateRecommendedAndRequestData(){
      this.getRecommendedStatistics();
      this.getAdoptRequestStatistics();
    },
    /*
    updateReportTreatmentData(){
      this.getReportStatistics();
      this.getTreatmentStatistics();
    },
    */
    //기간 바뀌면 바로 다시 조회
    onRecommendedPeriod(r){
      this.start_date2 = r.start;
      this.end_date2 = r.end;
      this.updateRecommendedAndRequestData();
    },
    onProtectPeriod(r){
      this.start_date = r.start;
      this.end_date = r.end;
      this.updateProtectData();
    },
    periodText(s, e){
      return moment(s).format('YYYY.MM.DD') + ' ~ ' + moment(e).format('YYYY.MM.DD');
    },
    //chart 데이터(labels + datasets[0].data) → 막대 항목
    barItems(chart, colors){
      const data = chart.datasets[0].data || [];
      return chart.labels.map((label, k) => ({ label, value: Number(data[k]) || 0, color: colors[k] }));
    },

    redirectStatisticsPage(){
        // this.router.push('https://pf.kakao.com/_vxaxbUxl')
        window.open('https://pawinhand.kr/service/statistics.html', "_blank");
    },

    refreshStatistics(){
      this.recommended_all_cnt = 0,
      this.request_all_cnt = 0,
      this.animal_all_cnt = 0,

      this.getRecommendedStatistics();
      this.getAdoptRequestStatistics();

      this.getAnimalStatistics();
      this.getAdoptRankByCity();
      this.getEuthRankByCity();
    },

    loadTodo(force){
      if (this.shelter && this.shelter.shelter_device_number && this.shelter.shelter_device_number != 'admin@pasm.kr') {
        loadTodo(this.axios, this.shelter.shelter_device_number, force);
      }
    },

    shelterSelected(event){

      let shelter_name = event.target.value;
      let index = event.target.selectedIndex -1;

      if(shelter_name != '보호소' && !!shelter_name){
          
          this.shelter = this.$root.admin.shelterList[index];

          this.refreshStatistics();
          this.loadTodo(true);

          this.emitter.emit('selectedShelterByAdmin', this.shelter);
          
          this.$cookies.set('adminAdoptionManageShelter', this.shelter.shelter_device_number);

      }else{
          this.requestList = [];
      }

    },


  },
  mounted(){
    this.emitter.emit('headerActiveCheck', "home");
    this.loadTodo(true);

    this.getRecommendedStatistics();
    this.getAdoptRequestStatistics();

    this.getAnimalStatistics();
    this.getAdoptRankByCity();
    this.getEuthRankByCity();
    // this.getReportStatistics();
    // this.getTreatmentStatistics();
    // this.testDate()
    // this.cachingDate();

    if (!!!this.$cookies.get('revisit')) {
        this.$cookies.set('revisit', true);

        this.$vgt.start(0)
    }

  },
  created(){
    if(!this.$store.state.auth.status.loggedIn){
      this.$router.push('/login');
    }

    this.shelter = this.$root.shelter;

    if(this.$root.isAdmin){
        if(!!this.$cookies.get('adminAdoptionManageShelter')){
            let load_shelter = this.$cookies.get('adminAdoptionManageShelter');

            const matched = this.$root.admin.shelterList.find(
                s => s.shelter_device_number === load_shelter
                );
                if (matched) {
                this.shelter = matched;
            }

            this.admin_shelter = this.shelter.shelter_name;

        }
    }
  },
}
</script>
<style scoped>
  .home-todo { margin-top: 1.6rem; text-align: left; }
  .home-todo-head { margin-bottom: 0.7rem; align-items: baseline; }
  .home-todo-cards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; }
  .home-todo-card {
    display: flex; flex-direction: column; align-items: flex-start; gap: 4px; text-align: left;
    border: 1px solid #ececec; background: #fff; border-radius: 10px; padding: 12px 14px; transition: border-color .15s, box-shadow .15s;
  }
  .home-todo-card:hover { border-color: #f6951c; box-shadow: 0 2px 8px rgba(246, 149, 28, .12); }
  .home-todo-card.has { border-color: #FAD3A4; background: #FFFBF5; }
  .home-todo-label { font-size: 13.5px !important; color: #555; font-weight: 600; }
  .home-todo-count { font-size: 24px !important; font-weight: 800; color: #c0c0c0; line-height: 1.2; }
  .home-todo-card.has .home-todo-count { color: #f6951c; }
  .home-todo-count small { font-size: 13px; font-weight: 600; margin-left: 2px; }
  .home-todo-extra { font-size: 12px !important; font-weight: 700; color: #E53935; }
  /* 홈 통계 (막대 카드) */
  .home-stat-head { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; margin: 2.2rem 0 0.8rem; text-align: left; }
  .home-stat-head h4 { font-weight: 700; }
  .home-period { margin: 4px 0 0 !important; font-size: 13px !important; color: #888; font-variant-numeric: tabular-nums; }
  .home-bars-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
  .home-rank { display: flex; align-items: center; justify-content: center; gap: 14px; margin-top: 1.6rem; padding: 1.4rem 1rem; border-top: 1px solid #ededed; border-bottom: 1px solid #ededed; }
  .home-rank p { font-size: 17px !important; color: #333; }
  .home-rank b { color: #F6951C; font-size: 19px; }
  .home-rank-sep { color: #ccc; margin: 0 4px; }
  .home-rank .btn-orange { padding: 4px 18px !important; font-size: 15px !important; }
  @media (max-width: 768px) {
    .home-stat-head { flex-direction: column; align-items: stretch; gap: 8px; }
    .home-bars-grid { grid-template-columns: 1fr; }
    .home-rank { flex-direction: column; gap: 10px; padding: 1.2rem 0.5rem; }
    .home-rank p { font-size: 15px !important; text-align: center; }
    .home-rank .btn-orange { min-height: 44px; }
    .home-todo-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .home-todo-card { min-height: 72px; }
    .home-admin-bar { flex-wrap: wrap; gap: 8px; justify-content: flex-end; }
    .home-admin-bar .navbar-brand { margin-right: 0 !important; }
  }

  .orange_bar::after{
    content: "";
    display: block;
    width: 5rem;
    height: 1rem;
    border-radius: 1.5625vw;
    background-image: linear-gradient(270deg, #f77706, #f5c45a);
  }

</style>